import { render, staticRenderFns } from "./StopSending.vue?vue&type=template&id=3a0700fb&scoped=true&"
import script from "./StopSending.vue?vue&type=script&lang=js&"
export * from "./StopSending.vue?vue&type=script&lang=js&"
import style0 from "styles/components/stopSending.css?vue&type=style&index=0&id=3a0700fb&scoped=true&lang=css&"
import style1 from "./StopSending.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0700fb",
  null
  
)

export default component.exports